import { Money } from '../../utils/money';
import { User } from '../common/authentication';
import { RecurrentExpense } from './recurrent-expenses';

export enum ExpenseMode {
  MANUAL = 'MANUAL',
  RECURRING = 'RECURRING',
  SALARY = 'SALARY',
}

export enum ExpenseStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
}

export interface ExpenseCategory {
  id: number;
  label: string;
  is_active: boolean;
}

export interface Expense {
  id: number;
  category?: ExpenseCategory;
  description: string;
  expense: Money[];
  mode: ExpenseMode;
  paid_at?: string;
  payment_recorded_at?: string;
  status: ExpenseStatus;
  created_at?: string;
  created_by?: User;
  paid_by?: User;
  cancelled_by?: User;
  cancelled_at?: string;
  due_date?: string;
  is_overdue?: boolean;
  recurring_template?: RecurrentExpense;
}
